import { defineAsyncComponent } from 'vue'
export default {
  auth: defineAsyncComponent(() => import("/Users/rayyach/Desktop/sites/saveAtCost.co/layouts/auth.vue").then(m => m.default || m)),
  dashboard: defineAsyncComponent(() => import("/Users/rayyach/Desktop/sites/saveAtCost.co/layouts/dashboard.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/Users/rayyach/Desktop/sites/saveAtCost.co/layouts/default.vue").then(m => m.default || m))
}